import styled from 'styled-components';

export const UiLibraryPage = styled.div`
`;